// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"0052fa4a","193":"b60337fd","331":"5e46e67d","429":"cbb1a458","438":"ab125041","637":"fa8a9047","787":"53414382"}[chunkId] + ".chunk.js";
};